import { useCallback } from 'react'
import { useConnectApp, useDisconnectApp } from '@/features/integrations'

/**
 * Row menu actions for Settings → Connections.
 *
 * Re-authenticate repairs rather than deleting first: Composio deprecated
 * manual refresh (it rotates credentials in the background), and destroying a
 * working account to fix a broken one would lose access outright if the user
 * abandoned the consent screen. It needs the `reconnect` flag — without it the
 * server answers 409 already-connected and the button does nothing at all,
 * which is precisely the case it exists for.
 */
export function useConnectionRowMenuActions({ menuRowId, connections, onPermissions, onUnavailable }) {
  const disconnect = useDisconnectApp()
  const connect = useConnectApp()

  return useCallback(
    (itemId) => {
      if (menuRowId == null) return

      if (itemId === 'connection-permissions') {
        onPermissions?.(menuRowId)
        return
      }

      if (itemId === 'connection-remove' || itemId === 'connection-delete') {
        disconnect.mutate({ connectionId: menuRowId })
        return
      }
      if (itemId === 'connection-reauthenticate') {
        const row = connections.find((r) => r.id === menuRowId)
        if (row?.toolkitSlug) connect.mutate({ toolkitSlug: row.toolkitSlug, reconnect: true })
        return
      }
      if (itemId === 'connection-nickname' || itemId === 'connection-share') onUnavailable?.(itemId)
    },
    [menuRowId, connections, disconnect, connect, onPermissions, onUnavailable],
  )
}
